// https://www.educative.io/answers/how-to-dynamically-load-a-js-file-in-javascript
var lazyLoadJsPromises = {}
var lazyLoadJs = function (javascriptid, javascriptsrc, async = true) {
	if (lazyLoadJsPromises[javascriptid]) {
		return lazyLoadJsPromises[javascriptid]
	}

	lazyLoadJsPromises[javascriptid] = new Promise((resolve, reject) => {
		try {
			if (document.getElementById(javascriptid) == null) {
				let scriptEle = document.createElement('script')
				scriptEle.setAttribute('src', javascriptsrc)
				scriptEle.setAttribute('type', 'text/javascript')
				scriptEle.setAttribute('async', async)

				scriptEle.id = javascriptid
				document.body.appendChild(scriptEle)
				scriptEle.addEventListener('load', () => {
					resolve({ status: true })
				})
				scriptEle.addEventListener('error', (ev) => {
					reject({
						status: false,
						message: `Failed to load the script ${javascriptsrc}`,
					})
				})
			} else {
				// was already loaded!
				var existingScript = document.getElementById(javascriptid)
				if (existingScript && existingScript.getAttribute('data-lay-script-loaded') !== '1') {
					existingScript.addEventListener('load', () => {
						resolve({ status: true })
					})
					existingScript.addEventListener('error', () => {
						reject({
							status: false,
							message: `Failed to load the script ${javascriptsrc}`,
						})
					})
				} else {
					resolve({ status: true })
				}
			}
		} catch (error) {
			reject(error)
		}
	}).then((result) => {
		var script = document.getElementById(javascriptid)
		if (script) {
			script.setAttribute('data-lay-script-loaded', '1')
		}
		return result
	})
	return lazyLoadJsPromises[javascriptid]
}

var getPhysicsRoot = function ($target, $dragPhysics) {
	var targetEl = $target && $target.jquery ? $target[0] : null
	if (targetEl) {
		if (targetEl.classList && (targetEl.classList.contains('lay-content') || targetEl.classList.contains('lay-overlay'))) {
			return targetEl
		}
		if (targetEl.closest) {
			var targetRoot = targetEl.closest('.lay-content, .lay-overlay')
			if (targetRoot) return targetRoot
		}
	}
	var physicsEl = $dragPhysics && $dragPhysics.length ? $dragPhysics[0] : null
	return (physicsEl && physicsEl.closest && physicsEl.closest('.lay-content, .lay-overlay')) || document
}

var getDragPhysicsElements = function ($dragPhysicsTarget) {
	if (!$dragPhysicsTarget || !$dragPhysicsTarget.jquery) {
		$dragPhysicsTarget = window.jQuery(document)
	}
	var $dragPhysics = $dragPhysicsTarget.find('[data-lay-drag-physics="1"]').add($dragPhysicsTarget.filter('[data-lay-drag-physics="1"]'))
	if (window.utility && window.utility.isPhoneSize) {
		$dragPhysics = $dragPhysics.filter(function () {
			return this.getAttribute('data-lay-drag-physics-disable-phone') !== '1' && this.getAttribute('data-lay-drag-physics-hide-phone') !== '1'
		})
	}
	return $dragPhysics
}

// Once drag_physics.min.js has been bootstrapped (first-time loaded
// AND its `i()` lifecycle listeners are registered), subsequent
// `content_ready` events do NOT need to call bind() from here — the
// controller's own `newpageshown` / `project_overlay_open_end` /
// `page_overlay_open_end` listeners handle re-binds for new scopes.
// The original "bind on every content_ready" path produced duplicate
// binds (content_ready fires multiple times per nav cycle), causing
// the physics engine to tear down and rebuild bodies in the same
// scope repeatedly — visible as physics restarting twice in a row.
var dragPhysicsBootstrapDone = false
var maybeLoadDragPhysics = function ($dragPhysicsTarget) {
	var $dragPhysics = getDragPhysicsElements($dragPhysicsTarget)
	if ($dragPhysics.length === 0) return

	lazyLoadJs('lay-drag-physics', layData.template_directory_uri + '/frontend/assets/js/drag_physics.min.js').then((data) => {
		if (dragPhysicsBootstrapDone) return
		dragPhysicsBootstrapDone = true
		if (window.layDragPhysicsController && typeof window.layDragPhysicsController.bind === 'function') {
			// One-shot bootstrap bind: ensures elements get bodies even
			// if the lifecycle events that triggered THIS content_ready
			// fired before the controller's `i()` registered listeners.
			window.layDragPhysicsController.bind(getPhysicsRoot($dragPhysicsTarget, $dragPhysics))
		}
	})
}

window.laytheme.on('content_ready', function (typeOfContentThatIsReady, $contentReadyTarget) {
	var $target = window.lt_utility_controller.utility_controller.getTargetContainers(typeOfContentThatIsReady)
	
	//
	//

	// need to lazyload webgl script, esp webgl slideshow js
	// because it doubles the size of the bundle. and many people dont even use row webgl backgrounds...

	// lazyload webgl slideshows js. and then initialize it:
	var $webgl_slideshow = $target.find('.lay-webgl-slideshow:not(.webgl-initialized)')
	var $webgl_carousel = $target.find('.lay-carousel.transition-webgl:not(.webgl-initialized)')
	if ($webgl_slideshow.length > 0 || $webgl_carousel.length > 0) {
		lazyLoadJs('lay-webgl-row-background-slideshow', layData.template_directory_uri + '/frontend/assets/js/webgl_row_background_slideshow.min.js').then((data) => {
			// wait until sizes attribute was set :)
			setTimeout(() => {
				if ($webgl_slideshow.length > 0) window.initWebGlBackgrounds($webgl_slideshow)
				if ($webgl_carousel.length > 0 && typeof window.initWebGLCarousels === 'function') window.initWebGLCarousels($webgl_carousel)
			}, 100)
		})
	}

	var $row_canvas_animations = $target.find('.lay-row-canvas-animation:not(.canvas-animation-initialized)').add($target.filter('.lay-row-canvas-animation:not(.canvas-animation-initialized)'))
	if ($row_canvas_animations.length > 0) {
		lazyLoadJs('lay-row-canvas-animation', layData.template_directory_uri + '/frontend/assets/js/row_canvas_animation.min.js').then(() => {
			if (typeof window.initRowCanvasAnimations === 'function') window.initRowCanvasAnimations($row_canvas_animations)
		})
	}

	// lazyload marquee js. and then initialize it:
	var $marquee = $target.find('.lay-marquee')
	if ($marquee.length > 0) {
		lazyLoadJs('lay-marquee', layData.template_directory_uri + '/frontend/assets/js/marquee.min.js').then((data) => {
			window.initMarquees($marquee, { insidePageOverlay: false })
		})
	}

	// Drag Physics depends on Matter.js. Keep that physics engine out of the
	// regular frontend bundle and only load it on pages that actually render
	// draggable physics elements.
	var $dragPhysicsTarget = $contentReadyTarget && $contentReadyTarget.jquery ? $contentReadyTarget : $target
	maybeLoadDragPhysics($dragPhysicsTarget)
})

// Initial/direct loads can already have physics markup in the server-rendered
// page before `content_ready` gives this lazyloader a scoped target. Scan the
// visible document once as a fallback; subsequent calls are safe because
// lazyLoadJs() is idempotent and bind() cleans up before re-binding.
window.jQuery(function () {
	maybeLoadDragPhysics(window.jQuery(document))
})

window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
	window.requestAnimationFrame(function () {
		maybeLoadDragPhysics(window.jQuery(document))
	})
})

// A page can load at phone size with every physics element phone-disabled
// — `getDragPhysicsElements` then filters them all out and
// `maybeLoadDragPhysics` (correctly) skips loading the Matter.js bundle.
// But if the user resizes UP to desktop those elements become active and
// the engine must load. `content_ready` on resize only hands this
// lazyloader a scoped (and possibly stale) target that misses the physics
// markup, and `newpageshown` doesn't fire on a resize — so the bundle
// would never load. Re-scan the whole document on width changes until the
// bundle has bootstrapped; after that the controller's own
// `window_width_changed` listener owns rebinds, so we stop.
window.jQuery(window).on('window_width_changed', function () {
	if (dragPhysicsBootstrapDone) return
	maybeLoadDragPhysics(window.jQuery(document))
})
